import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
import { PricingInputDTO, PricingOutputDTO } from 'src/services/reservation/pricing/pricingDTO'
class PricingServices {
  async updateById(id: number, body: PricingInputDTO): Promise<PricingOutputDTO> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/pricing/${id}`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async calculateLiquidationRuleFromPricing(id: number, body: PricingInputDTO): Promise<PricingOutputDTO> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/pricing/updatePricingAndLiquidation/${id}`,
        {
          pricing: { ...body },
          liquidation: { liquidations: body.liquidations },
        },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async get_pricing_version(ent_id:number, version_id:number | null = null):Promise<any>{
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/pricing/${ent_id}/version/`,  {
        headers: { 'authentication-token': getJWT()! },
        params:{
          version_id
        }
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async reliquidate_wholesaler(hash_item_array:string[]):Promise<any>{
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/pricing/reliquidation-wholesaler/`, 
      hash_item_array, 
      {
        headers: { 'authentication-token': getJWT()! }
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async reliquidate_retail(hash_item_array:string[]):Promise<any>{
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/pricing/reliquidation-retail/`, 
      hash_item_array, 
      {
        headers: { 'authentication-token': getJWT()! }
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async reliquidate_supplier(hash_item_array:string[]):Promise<any>{
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/pricing/reliquidation-supplier/`, 
      hash_item_array, 
      {
        headers: { 'authentication-token': getJWT()! }
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const pricingServices = new PricingServices()
